export enum CountryCode {
  /**************************
   *
   * European-level countries
   *
   **************************/
  AL = 'AL', // Albania
  AT = 'AT', // Austria
  BE = 'BE', // Belgium
  BA = 'BA', // Bosnia and Herzegovina
  BG = 'BG', // Bulgaria
  HR = 'HR', // Croatia
  CY = 'CY', // Cyprus
  CZ = 'CZ', // Czech Republic
  DK = 'DK', // Denmark
  EE = 'EE', // Estonia
  FI = 'FI', // Finland
  FR = 'FR', // France
  DE = 'DE', // Germany
  EL = 'EL', // Greece
  HU = 'HU', // Hungary
  IS = 'IS', // Iceland
  IE = 'IE', // Ireland
  IL = 'IL', // Israel
  IT = 'IT', // Italy
  LV = 'LV', // Latvia
  LI = 'LI', // Liechtenstein
  LT = 'LT', // Lithuania
  LU = 'LU', // Luxembourg
  MT = 'MT', // Malta
  ME = 'ME', // Montenegro
  NL = 'NL', // Netherlands
  NO = 'NO', // Norway
  PL = 'PL', // Poland
  PT = 'PT', // Portugal
  MK = 'MK', // Republic of North Macedonia
  RO = 'RO', // Romania
  RS = 'RS', // Serbia
  SK = 'SK', // Slovakia
  SI = 'SI', // Slovenia
  ES = 'ES', // Spain
  SE = 'SE', // Sweden
  TR = 'TR', // Turkey
  UA = 'UA', // Ukraine

  /**************************
   *
   * International-level countries
   *
   **************************/
  AF = 'AF', // Afghanistan
  DZ = 'DZ', // Algeria
  AS = 'AS', // American Samoa
  AD = 'AD', // Andorra
  AO = 'AO', // Angola
  AI = 'AI', // Anguilla
  AQ = 'AQ', // Antarctica
  AG = 'AG', // Antigua and Barbuda
  AR = 'AR', // Argentina
  AM = 'AM', // Armenia
  AW = 'AW', // Aruba
  AU = 'AU', // Australia
  AZ = 'AZ', // Azerbaijan
  BS = 'BS', // Bahamas
  BH = 'BH', // Bahrain
  BD = 'BD', // Bangladesh
  BB = 'BB', // Barbados
  BY = 'BY', // Belarus
  BZ = 'BZ', // Belize
  BJ = 'BJ', // Benin
  BM = 'BM', // Bermuda
  BT = 'BT', // Bhutan
  BO = 'BO', // Bolivia
  BW = 'BW', // Botswana
  BV = 'BV', // Bouvet Island
  BR = 'BR', // Brazil
  IO = 'IO', // British Indian Ocean Territory
  VG = 'VG', // Brit. Virgin Is.
  BN = 'BN', // Brunei
  BF = 'BF', // Burkina Faso
  BI = 'BI', // Burundi
  KH = 'KH', // Cambodia (Kampuchea)
  CM = 'CM', // Cameroon
  CA = 'CA', // Canada
  CV = 'CV', // Cape Verde
  KY = 'KY', // Cayman Islands
  CF = 'CF', // Central African Republic
  TD = 'TD', // Chad
  CL = 'CL', // Chile
  CN = 'CN', // China
  CX = 'CX', // Christmas Island
  CC = 'CC', // Cocos Islands (or Keeling Islands)
  CO = 'CO', // Colombia
  KM = 'KM', // Comoros (excluding Mayotte)
  CD = 'CD', // Congo Democratic Republic of
  CG = 'CG', // Congo (Republic of)
  CK = 'CK', // Cook Islands
  CR = 'CR', // Costa Rica
  CU = 'CU', // Cuba
  DJ = 'DJ', // Djibouti
  DM = 'DM', // Dominica
  DO = 'DO', // Dominican Republic
  TL = 'TL', // East Timor
  EC = 'EC', // Ecuador
  EG = 'EG', // Egypt
  SV = 'SV', // El Salvador
  GQ = 'GQ', // Equatorial Guinea
  ER = 'ER', // Eritrea
  ET = 'ET', // Ethiopia
  FK = 'FK', // Falkland Islands
  FO = 'FO', // Faroe Islands
  FJ = 'FJ', // Fiji
  PF = 'PF', // French Polynesia
  TF = 'TF', // French Southern Territories
  GA = 'GA', // Gabon
  GM = 'GM', // Gambia
  GE = 'GE', // Georgia
  GH = 'GH', // Ghana
  GI = 'GI', // Gibraltar
  GL = 'GL', // Greenland
  GD = 'GD', // Grenada
  GU = 'GU', // Guam
  GT = 'GT', // Guatemala
  GN = 'GN', // Guinea
  GW = 'GW', // Guinea Bissau
  GY = 'GY', // Guyana
  HT = 'HT', // Haiti
  HM = 'HM', // Heard Island and McDonald Islands
  HN = 'HN', // Honduras
  HK = 'HK', // Hong Kong
  IN = 'IN', // India
  ID = 'ID', // Indonesia
  IR = 'IR', // Iran
  IQ = 'IQ', // Iraq
  CI = 'CI', // Ivory Coast
  JM = 'JM', // Jamaica
  JP = 'JP', // Japan
  JO = 'JO', // Jordan
  KZ = 'KZ', // Kazakhstan
  KE = 'KE', // Kenya
  KI = 'KI', // Kiribati
  XK = 'XK', // Kosovo (As defined by United Nations Security Council Resolution 1244/1999)
  KW = 'KW', // Kuwait
  KG = 'KG', // Kyrgyzstan
  LA = 'LA', // Laos
  LB = 'LB', // Lebanon
  LS = 'LS', // Lesotho
  LR = 'LR', // Liberia
  LY = 'LY', // Libya
  MO = 'MO', // Macao
  MG = 'MG', // Madagascar
  MW = 'MW', // Malawi
  MY = 'MY', // Malaysia
  MV = 'MV', // Maldives
  ML = 'ML', // Mali
  MR = 'MR', // Mauritania
  MU = 'MU', // Mauritius
  YT = 'YT', // Mayotte
  MX = 'MX', // Mexico
  FM = 'FM', // Micronesia, Federated States of
  MD = 'MD', // Moldova
  MN = 'MN', // Mongolia
  MS = 'MS', // Montserrat
  MA = 'MA', // Morocco
  MZ = 'MZ', // Mozambique
  MM = 'MM', // Myanmar
  NA = 'NA', // Namibia
  NR = 'NR', // Nauru
  NP = 'NP', // Nepal
  AN = 'AN', // Netherlands Antilles
  NC = 'NC', // New Caledonia and dependencies
  NZ = 'NZ', // New Zealand
  NI = 'NI', // Nicaragua
  NE = 'NE', // Niger
  NG = 'NG', // Nigeria
  NU = 'NU', // Niue Island
  NF = 'NF', // Norfolk Island
  MP = 'MP', // Northern Mariana Islands
  KP = 'KP', // North Korea
  PS = 'PS', // Occupied palestinian Territory
  OM = 'OM', // Oman
  PK = 'PK', // Pakistan
  PW = 'PW', // Palau
  PA = 'PA', // Panama
  PG = 'PG', // Papua New Guinea
  PY = 'PY', // Paraguay
  PE = 'PE', // Peru
  PH = 'PH', // Philippines
  PN = 'PN', // Pitcairn
  QA = 'QA', // Qatar
  MH = 'MH', // Rep. of the Marshall Islands
  RU = 'RU', // Russian Federation
  RW = 'RW', // Rwanda
  WS = 'WS', // Samoa
  SM = 'SM', // San Marino
  ST = 'ST', // São Tomé and Principe
  SA = 'SA', // Saudi Arabia
  SN = 'SN', // Senegal
  SC = 'SC', // Seychelles and dependencies
  SL = 'SL', // Sierra Leone
  SG = 'SG', // Singapore
  SB = 'SB', // Solomon Islands
  SO = 'SO', // Somalia
  ZA = 'ZA', // South Africa
  GS = 'GS', // South Georgia and South Sandwich Islands
  KR = 'KR', // South Korea
  LK = 'LK', // Sri Lanka
  SH = 'SH', // St Helena and dependencies
  KN = 'KN', // St Kitts and Nevis
  LC = 'LC', // St. Lucia
  PM = 'PM', // St Pierre and Miquelon
  VC = 'VC', // St Vincent and the Grenadines
  SD = 'SD', // Sudan
  SR = 'SR', // Surinam
  SZ = 'SZ', // Swaziland
  CH = 'CH', // Switzerland
  SY = 'SY', // Syria
  TW = 'TW', // Taiwan
  TJ = 'TJ', // Tajikistan
  TZ = 'TZ', // Tanzania
  TH = 'TH', // Thailand
  TG = 'TG', // Togo
  TK = 'TK', // Tokelau
  TO = 'TO', // Tonga
  TT = 'TT', // Trinidad and Tobago
  TN = 'TN', // Tunisia
  TM = 'TM', // Turkmenistan
  TC = 'TC', // Turks and Caicos Islands
  TV = 'TV', // Tuvalu
  UG = 'UG', // Uganda
  AE = 'AE', // United Arab Emirates
  UK = 'UK', // United Kingdom
  US = 'US', // United States
  UM = 'UM', // United States Minor outlying islands
  UY = 'UY', // Uruguay
  UZ = 'UZ', // Uzbekistan
  VU = 'VU', // Vanuatu
  VA = 'VA', // Vatican City State
  VE = 'VE', // Venezuela
  VN = 'VN', // Vietnam
  VI = 'VI', // Virgin Islands of U.S.
  WF = 'WF', // Wallis and Futuna Islands
  YE = 'YE', // Yemen
  ZM = 'ZM', // Zambia
  ZW = 'ZW', // Zimbabwe
}
